import { batch } from 'react-redux'

import { ActionService } from 'dashboard-services/services'

export default (() => {

  const ON_CHANGE = 'ON_CHANGE_GROUP_DIALOG_DL'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const RESET = 'RESET_GROUP_DIALOG_DL'
  const close = ActionService.makeActionCreator(RESET)

  const MODES = {
    CREATE: "CREATE",
    EDIT: "EDIT",
    SHARE: "SHARE",
    CONFIGURATION: "CONFIGURATION"
  }

  const TABS = {
    DETAILS: "Details",
    ADVANCED: "Advanced",
    SHARE: "Share"
  }

  const DEFAULT_TAB = {
    [MODES.CREATE]: TABS.DETAILS,
    [MODES.EDIT]: TABS.DETAILS,
    [MODES.SHARE]: TABS.SHARE,
    [MODES.CONFIGURATION]: TABS.ADVANCED
  }

  const open = ({ mode, tab, groupName, description, fields, groupTags, owner, canBeShared = false }) => dispatch => batch(() => {
    dispatch(onChange(mode, "mode"))
    dispatch(onChange(tab || DEFAULT_TAB[mode], "tab"))
    dispatch(onChange(groupName, "groupName"))
    dispatch(onChange(description, "description"))
    dispatch(onChange(fields, "fields"))
    dispatch(onChange(groupTags, "groupTags"))
    dispatch(onChange(owner, "owner"))
    dispatch(onChange(canBeShared, "canBeShared"))
    dispatch(onChange(true, "isOpen"))
  })

  return {
    ON_CHANGE,
    onChange,
    RESET,
    close,
    MODES,
    TABS,
    DEFAULT_TAB,
    open
  }
})()
